var React = require('react');

function Shadow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("filter",{"x":"-10.2%","y":"-10.2%","width":"120.3%","height":"120.3%","filterUnits":"objectBoundingBox","id":"filter-1"},React.createElement("feGaussianBlur",{"stdDeviation":"10","in":"SourceGraphic"}))),React.createElement("g",{"id":"Homepage","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Homepage-slider-1","transform":"translate(-19.000000, -921.000000)","fill":"#D8D8D8","stroke":"#979797"},React.createElement("circle",{"id":"Oval","filter":"url(#filter-1)","cx":"191.5","cy":"1093.5","r":"147"})))]);
}

Shadow.defaultProps = {"width":"345px","height":"345px","viewBox":"0 0 345 345","version":"1.1"};

module.exports = Shadow;

Shadow.default = Shadow;
